module.exports = __webpack_public_path__ + "img/icon-check.3084e9d2.svg";